<template>
     
    <div>
        <div class="text-left mb-3">
            <h3 class="mb-3">{{$t('cal_comm_title')}}</h3>
            <p>{{$t('cal_comm_title_txt')}}</p>
        </div>
        <div class="verticallyTab mt-5">
			<p v-if="message != ''" style="color:red">{{message}}</p>
            <div class="bottomTab">
                <div class="stepForm-contact mt-5">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="segm"  @change="currencyList()" v-validate="'required'" name="segm" :class="{ 'is-invalid': submitted && errors.has('segm'), 'active' : segm != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <option value="Forex">{{$t('cal_comm_forex')}}</option>
                                    <option value="Commodities">{{$t('cal_comm_commodities')}}</option>
                                    <option value="INDICIES">{{$t('cal_comm_indices')}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_comm_Asset_Class')}}</label>
								 <p class="error" v-if="submitted" v-for="error in errors.collect('segm')">{{$t('cal_comm_Field_req')}}</p>  
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="basecurreny" v-validate="'required'" name="basecurreny" :class="{ 'is-invalid': submitted && errors.has('basecurreny'), 'active' : basecurreny != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <option value="USD">{{$t('cal_comm_USD')}}</option>
                                    <option value="GBP">{{$t('cal_comm_GBP')}}</option>
                                    <option value="AUD">{{$t('cal_comm_AUD')}}</option>
                                    <option value="EUR">{{$t('cal_comm_EUR')}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_comm_accBaseCurr')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('basecurreny')">{{$t('cal_comm_Field_req')}}</p> 
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="selectedSymbol"  v-validate="'required'" name="selectedSymbol" :class="{ 'is-invalid': submitted && errors.has('selectedSymbol'), 'active' : selectedSymbol != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <option v-for="value in allIsinsList" :value="value">{{value}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_comm_Symbol')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbol')">{{$t('cal_comm_Field_req')}}</p> 
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input type="text" v-model="tradesize" class="float-field form-control"  v-validate="{ required: true,decimal:5}" name="tradesize" :class="{ 'is-invalid': submitted && errors.has('tradesize') }">
                                <label class="float-label" style="text-transform: none !important;">{{$t('cal_comm_trade_size_lot')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('tradesize')">{{$t('cal_comm_Field_req')}}</p> 
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn" v-on:click.prevent="calculateComm()">{{$t('cal_comm_now')}}</a>
                                <p class="mt-3">{{$t('cal_comm_Comm_roundT')}}: {{basecurreny}} {{commission.toFixed(2)}} </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        
</template>
<script>
    import * as types from '@/types'
    import { fxViewMixins } from '@/plugins/fxView' 
    // import { ProviderCacheMixins } from '@/plugins/vue-provider-cache/mixin'
    export default {
        name: 'Commision',
        mixins: [fxViewMixins],
        // mixins: [ProviderCacheMixins],
        data() {
            return {
                isins:'',
                "segm": 'Forex',
                "tradesize": 0,
                selectedSymbol:"",
                "selectedSeg":"",
                "commission": 0,
                "basecurreny":'USD',
				submitted : false,
				message : '',
                allIsinsList:'',
                allIsins:''
            }
        },
        methods:{
            currencyList(){
                this.isinList=""
                this.allIsins = this.$store.getters['/GET_ISINS_LIST'];
                this.allIsinsList = Object.keys(this.allIsins).filter(key => this.allIsins[key].type === this.segm);

                return this.allIsinsList;
            },
            calculateComm(){
				const _that = this
                this.submitted = true;
				this.message = ''
                let fetchedSelectedSymbol=""
                let firstCurrency=''
                const match = _that.selectedSymbol.match(/\((.*?)\)/); // Regex to find text within brackets
                if (match) {
                    fetchedSelectedSymbol = match[0]; // Get the content inside the brackets
                }else {
                    fetchedSelectedSymbol = _that.selectedSymbol; // No brackets found
                }
                
                let selectedIsin= this.allIsins[_that.selectedSymbol]
                let priceFeed= this.$store.getters['/GET_PRICEFEED_DATA'];
                let selectedIsinPrice= priceFeed[fetchedSelectedSymbol]
                this.$validator.validate().then(valid => {
                    if (valid) {
						let commissionCal=""
                        commissionCal= ((selectedIsin.Contract_Size*_that.tradesize*selectedIsinPrice.A)*2)/100000

                        if(_that.segm=='Shares'){
                            firstCurrency="USD"
                        }else{
                            if(_that.selectedSymbol.includes('.') || _that.selectedSymbol.includes('(')){
                            if(_that.selectedSymbol.includes('.')){
                                let lastSymbol=_that.selectedSymbol.trim('.')
                                firstCurrency = lastSymbol.slice('3','6')
                            }else if(_that.selectedSymbol.includes('(')){
                                let lastSymbol=_that.selectedSymbol.split('(')[0]
                                firstCurrency = lastSymbol.slice('3','6')
                            }
                            }else if(_that.selectedSymbol.includes('-')){
                            let lastSymbol=_that.selectedSymbol.replace('-', '')
                            firstCurrency = lastSymbol.slice('3','6')
                            }else{                            
                            firstCurrency = _that.selectedSymbol.slice('3','6')
                            }
                        }
                        if(firstCurrency == _that.basecurreny){
                            let secCurrencyPrice = 1
                            _that.commission= commissionCal/secCurrencyPrice
                        }else{
                            let secondaryCurrencyPrice = priceFeed[firstCurrency+_that.basecurreny]
                            if(secondaryCurrencyPrice){
                                _that.commission = secondaryCurrencyPrice.A*commissionCal
                            }else if(priceFeed[_that.basecurreny+firstCurrency]){
                                secondaryCurrencyPrice = priceFeed[_that.basecurreny+firstCurrency]
                                _that.commission = (1/secondaryCurrencyPrice.A)*commissionCal
                            }else{                        
                                let allIsinList = []
                                let filteredIsins=[]
                                let secondPrice=''
                                allIsinList= Object.keys(this.allIsins)
                                filteredIsins = allIsinList.filter(val=>val.includes(firstCurrency)&&val.includes("USD"))
                                let filteredIsinsSecond=[]
                                filteredIsinsSecond = allIsinList.filter(val=>val.includes(_that.basecurreny))
                                let filteredIsinsSecondPrice= priceFeed[filteredIsinsSecond[0]]
                                secondPrice= 1/filteredIsinsSecondPrice.A
                                filteredIsins.forEach(val=>{
                                    if(val.slice(0,3)=='USD'){
                                        let price= priceFeed['USD'+firstCurrency]
                                        _that.commission= (price.A*secondPrice)*commissionCal    
                                    }else if(val.slice(3,6)){
                                        let price= priceFeed[firstCurrency+'USD']
                                        
                                        _that.commission= (price.A*secondPrice)*commissionCal     
                                    }
                                })
                            }
                        }
					}
				})
                //selected symbol
            },
            // currencyConverstion(selectedSymbol){
            //     //all_currencies_price will get all currecies prices

            //      let secondCurrency = selectedSymbol.substring(0, 3);

            //     if(secondCurrency == this.basecurreny){
            //         return 1
            //     }

            //     else if(this.all_currencies_price[secondCurrency+this.basecurreny]){
            //         return this.all_currencies_price[secondCurrency+this.basecurreny].A
            //     } 
 
            //     else if(this.all_currencies_price[this.basecurreny+secondCurrency]){
            //         return 1/this.all_currencies_price[this.basecurreny+secondCurrency].A
            //     } 
            //     else{

            //         let secontoUSD = 0
            //         let accBasetoUSD = 0
            //         if(this.all_currencies_price[secondCurrency+"USD"]){
            //             secontoUSD = this.all_currencies_price[secondCurrency+"USD"].A
            //         } 
            //         else if(this.all_currencies_price["USD"+secondCurrency]){
            //             secontoUSD = 1/this.all_currencies_price["USD"+secondCurrency].A
            //         } 

            //         if(this.basecurreny=="USD"){
            //             accBasetoUSD = 1
            //         }
            //         else if(this.all_currencies_price[this.basecurreny+"USD"]){
            //             accBasetoUSD = 1/this.all_currencies_price[this.basecurreny+"USD"].A
            //         } 
            //         else if(this.all_currencies_price["USD"+this.basecurreny]){
            //             accBasetoUSD = this.all_currencies_price["USD"+this.basecurreny].A
            //         } 

            //         return accBasetoUSD*secontoUSD
            //     }
            //     return 1
            // },
            // currencyConverstionSecond(selectedSymbol){
            //     //all_currencies_price will get all currecies prices

            //     let secondCurrency = selectedSymbol.substring(3, 6);

            //     if(secondCurrency == this.basecurreny){
            //         return 1
            //     }

            //     else if(this.all_currencies_price[secondCurrency+this.basecurreny]){
            //         return this.all_currencies_price[secondCurrency+this.basecurreny].A
            //     } 
 
            //     else if(this.all_currencies_price[this.basecurreny+secondCurrency]){
            //         return 1/this.all_currencies_price[this.basecurreny+secondCurrency].A
            //     } 
            //     else{

            //         let secontoUSD = 0
            //         let accBasetoUSD = 0
            //         if(this.all_currencies_price[secondCurrency+"USD"]){
            //             secontoUSD = this.all_currencies_price[secondCurrency+"USD"].A
            //         } 
            //         else if(this.all_currencies_price["USD"+secondCurrency]){
            //             secontoUSD = 1/this.all_currencies_price["USD"+secondCurrency].A
            //         } 

            //         if(this.basecurreny=="USD"){
            //             accBasetoUSD = 1
            //         }
            //         else if(this.all_currencies_price[this.basecurreny+"USD"]){
            //             accBasetoUSD = 1/this.all_currencies_price[this.basecurreny+"USD"].A
            //         } 
            //         else if(this.all_currencies_price["USD"+this.basecurreny]){
            //             accBasetoUSD = this.all_currencies_price["USD"+this.basecurreny].A
            //         } 

            //         return accBasetoUSD*secontoUSD
            //     }
            //     return 1
            // },

        },
        
        mounted() {
            this.currencyList()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/commission.vue